<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="authors-note">
<h1>Author’s Note</h1>
<p>My aim in writing this story is to encourage young people to follow their dreams. The importance of self-confidence is paramount and often under-estimated in life.</p>
<p>Many of the people in this book are based on real people; Jack McCulloch on Jack McNab. The account of events are as accurate as I can make them; although, not necessarily in the correct order.</p>
<p>However, I have tried to portray the language and attitudes of the time as a good comparison from today.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?2d052906